export default "__VITE_ASSET__Bm3QPOWM__"